import { QueryErrorResetBoundary } from "@tanstack/react-query"
import { ErrorBoundary } from "react-error-boundary"
import { useAtomValue } from "jotai"
import { errorBoundaryResetVersionAtom } from "~/atoms/error-boundary-reset"
import { ErrorFallback } from "~/components/error"

type FallbackProps = { error: unknown }

interface Props {
  children: React.ReactNode
  fallback?: React.ComponentType<FallbackProps>
}

export function QueryErrorBoundary({ children, fallback: Fallback = ErrorFallback }: Props) {
  const resetVersion = useAtomValue(errorBoundaryResetVersionAtom)

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          resetKeys={[resetVersion]}
          fallbackRender={({ error }) => <Fallback error={error} />}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
